import { createStore, applyMiddleware } from "redux";

import createSagaMiddleware from "redux-saga";
import rootReducer from "./reducers";

import sagas from "./saga";

const sagaMiddleware = createSagaMiddleware();

export const store = createStore(rootReducer, applyMiddleware(sagaMiddleware));

sagaMiddleware.run(sagas);

export default store;
